export default [
  {
    text: 'Ativar',
    value: 'ATIVO',
  },
  {
    text: 'Bloquear',
    value: 'BLOQUEADO',
  },
  {
    text: 'Inativar',
    value: 'INATIVO',
  },
];
